module.exports = __webpack_public_path__ + "img/tu-2_19.22bb98f7.jpg";